import React from "react"
import { Col, Row } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import { ItemCustomAttributesDisplayProps } from "../common/types"
import IntlProps from "../state/helpers/IntlProps"
import {
    CUSTOM_ATTRIBUTE_TYPE_SELECT,
    CUSTOM_ATTRIBUTE_TYPE_TEXT,
    getHoverAttributes,
    getSelectedAttributes,
    itemCustomAttributesMessages
} from "../utils/customAttributes"
import AttributesListItem from "./customAttributes/components/AttributesListItem"
import "./customAttributes/styles/styles.scss"

const ItemCustomAttributesDisplay = (props: ItemCustomAttributesDisplayProps & IntlProps) => {

    const matchDefnToValue = (props) => {
        const itemsList = [] as JSX.Element []
        const itemCustomAttributeValues = props.item?.attributes.itemCustomAttributeValues
        const itemCustomAttributeDefinitions = props.item?.attributes.itemCustomAttributeDefinitions

        if (itemCustomAttributeValues &&
            itemCustomAttributeValues.length > 0 &&
            itemCustomAttributeDefinitions &&
            itemCustomAttributeDefinitions.length > 0) {
            itemCustomAttributeDefinitions.forEach((def, index) => {
                const match = itemCustomAttributeValues.filter(val => val.attributes.customAttributeDefinitionId === def.id)
                const label = def.attributes.label !== "" ? def.attributes.label : def.attributes.customFieldDefinitionLabel.label
                let values = ""
                const displayMessage = 
                `(${props.intl.formatMessage(itemCustomAttributesMessages["quote.item_custom_attributes_display.not_specified_msg"])})`

                if(match === undefined || match?.length === 0 || def.attributes === undefined) {
                    return []
                }

                if(def.attributes.attributeType === CUSTOM_ATTRIBUTE_TYPE_TEXT.value) {
                    values = def.attributes.label !== "" ? match[0].attributes.value : match[0].attributes.textValue
                    if (values?.length === 0) {
                        values = displayMessage
                    }
                } else if(def.attributes.attributeType === CUSTOM_ATTRIBUTE_TYPE_SELECT.value && def.attributes.customFieldDefinitionLabel.metadata) {
                    values = getSelectedAttributes(match[0].attributes.selectValue, def.attributes.customFieldDefinitionLabel)
                }

                if(def.attributes !== undefined && label !== "") {
                    itemsList.push(
                        <AttributesListItem id={def.id}
                            attributeType={def.attributes.attributeType}
                            label={label}
                            required={match[0].attributes.required}
                            isLastItem={index === itemCustomAttributeDefinitions.length - 1}
                            hoverAttributes={getHoverAttributes(label, def)}
                            values={values}
                            displayMessage={displayMessage} />
                    )
                }
            })
        }
        return itemsList
    }
    
    return (
        <>
            {props.item?.attributes.itemCustomAttributeValues && props.item?.attributes.itemCustomAttributeValues.length > 0 && (
                <div className="d-flex flex-column">
                    <div className="d-flex">
                        <Row className="mb-1 attributes-container">
                            <Col>
                                <ul className="list-inline mb-0 line-height-xs">
                                    {matchDefnToValue(props)}
                                </ul>
                            </Col>
                        </Row>
                    </div>
            
                    <div className="d-flex align-self-start">
                        <small className="text-secondary">
                            <span className="text-danger small">*</span>
                            <FormattedMessage
                                id="product.item_custom_attributes_display_component.required_fields_label"
                                defaultMessage="Required fields"
                            />
                        </small>
                    </div>
                </div>
            )}
        </>
    )
}

export default injectIntl(ItemCustomAttributesDisplay)



// WEBPACK FOOTER //
// ./src/quote/ItemCustomAttributesDisplayComponent.tsx